import React, { createContext, useContext } from 'react';

import { defaultStepContext } from './constants';
import { getMessageBubblePositions, initializeStepContext } from './helpers';
import { StepContextInterface } from './types';

const StepContext = createContext(defaultStepContext);

export const StepWrapper: React.FC<
  React.PropsWithChildren<Partial<StepContextInterface>>
> = props => {
  const { children, messageBubblePositions, widgetComponents } = props;
  const calculatedMessageBubblePositions =
    messageBubblePositions || getMessageBubblePositions(widgetComponents ?? []);
  const contextValue = React.useMemo(() => {
    // delete children from props to avoid passing it to the context
    const context = {
      ...props,
      messageBubblePositions: calculatedMessageBubblePositions,
    };
    delete context.children;
    return initializeStepContext(context);
  }, [props, calculatedMessageBubblePositions]);

  return (
    <StepContext.Provider value={contextValue}>{children}</StepContext.Provider>
  );
};

export const useStepContext = () => useContext(StepContext);

export default StepWrapper;
